import { render } from "./profile_settings.vue?vue&type=template&id=0af20ddb&scoped=true"
import script from "./profile_settings.vue?vue&type=script&lang=js"
export * from "./profile_settings.vue?vue&type=script&lang=js"

import "./profile_settings.vue?vue&type=style&index=0&id=0af20ddb&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af20ddb"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QToggle,QInput});
